// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gehbP","placeholdersHeader":"styles_placeholdersHeader__26aKD","editorStyle":"styles_editorStyle__22Jkg","placeholdersBox":"styles_placeholdersBox__2Pk4n"};